import * as React from 'react';

import Box from 'sail/Box';
import Grid, {GridItem} from 'sail/Grid';
import Group from 'sail/Group';
import {ContentGroupItem} from 'docs/util';
import {Heading, Text} from 'sail/Text';
import {DocsIcon, Link} from 'docs/components';
import {VideoTranscript} from './VideoTranscript';
import {Tab} from '../Tabs/Tab';
import {TabGroup} from '../Tabs/TabGroup';

const PlaylistAboutTab = ({video}) => {
  const videoPresenters = video ? video.presenters : [];
  const videoResources = video ? video.resources : [];
  const videoRelatedDocs = video ? video.relatedDocs : [];

  return (
    <Tab>
      <Box margin={{top: 12, bottom: 24}} style={{width: '75%'}}>
        <Text size={16} lineHeight={24}>
          {video?.description}
        </Text>
      </Box>

      <Box flex={{alignItems: 'flex-end'}}>
        <Grid gap={20} style={{width: '100%'}}>
          <GridItem columnSpan={4}>
            <Heading color="gray600">Presenter</Heading>
            {videoPresenters &&
              videoPresenters.map((presenter) => {
                return (
                  <>
                    <Text
                      display="block"
                      align="left"
                      weight="bold"
                      size={24}
                      lineHeight={40}
                    >
                      {presenter.name}
                    </Text>
                    <Text
                      display="block"
                      align="left"
                      color="gray400"
                      size={14}
                    >
                      {presenter.title}
                    </Text>
                  </>
                );
              })}
          </GridItem>
          <GridItem columnSpan={4} column={5}>
            <Heading color="gray600">Related docs</Heading>
            {videoRelatedDocs &&
              videoRelatedDocs.map((doc) => {
                return (
                  <Group
                    direction="horizontal"
                    alignItems="center"
                    padding={{top: 12}}
                    spacing={8}
                  >
                    <DocsIcon category="general" icon="guide" size={16} />
                    <Link href={doc.url}>{doc.title}</Link>
                  </Group>
                );
              })}
          </GridItem>
          <GridItem columnSpan={4} column={9}>
            <Heading color="gray600">Resources</Heading>
            {videoResources &&
              videoResources.map((resource) => {
                return (
                  <Group
                    direction="horizontal"
                    alignItems="center"
                    padding={{top: 12}}
                    spacing={8}
                  >
                    <DocsIcon category="general" icon="github" size={16} />
                    <Link href={resource.url}>{resource.title}</Link>
                  </Group>
                );
              })}
          </GridItem>
        </Grid>
      </Box>
    </Tab>
  );
};

function PlaylistTabItems(video, currentTime) {
  return [
    new ContentGroupItem(
      'about',
      'About',
      (<PlaylistAboutTab video={video} />),
    ),
    new ContentGroupItem(
      'transcripts',
      'Transcripts',
      (
        <Tab>
          <VideoTranscript currentTime={currentTime} video={video} />
        </Tab>
      ),
    ),
  ];
}

export const PlaylistTabs = ({video, currentTime}) => {
  return (
    <TabGroup
      items={PlaylistTabItems(video, currentTime)}
      selector="tabs"
      pref={video.prefs}
    />
  );
};
